import React from 'react';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useOrderDetails } from '../../hooks/useOrderDetails';
import { useLanguage } from '../../locale/useLanguage';

import './ChooseTransactionView.css';
import { OrderHeader } from './components/OrderHeader/OrderHeader';
import { TransactionList } from './components/TransactionsList/TransactionList';

type ChooseTransactionViewProps = {};

export const ChooseTransactionView: React.FC<
  ChooseTransactionViewProps
> = () => {
  const [t] = useLanguage();
  const order = useOrderDetails();
  const back = useBack();

  return (
    <BaseLayout onBackClick={back} hasBack title={t('pageTitles.orderDetails')}>
      {order && (
        <div className="choose-transaction--container">
          <OrderHeader order={order} />
          <div className="choose-transaction--list">
            <TransactionList order={order} />
          </div>
        </div>
      )}
    </BaseLayout>
  );
};
